import React, { useCallback, useEffect, useState } from 'react';
import Filter from 'src/components/common/Filter';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Card from 'src/components/common/Card.redesign';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import useFetch from 'use-http';
import InvoiceableEntity from 'src/models/InvoiceableEntity';
import * as _ from 'lodash';
import { ODataOptions } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';
import { ITableConfig } from 'src/components/common/table';

const InvoicingPage = () => {
    const dispatch = useDispatch();
    const { get, response } = useFetch();
    const [invoiceableEntities, setInvoiceableEntities] = useState<PagedResultSet<InvoiceableEntity>>(undefined);
    const [filters, setFilters] = useState('');
    const [isOnLastPage, setIsOnLastPage] = useState<boolean>(false);
    
    const initialInvoicingConfig: ITableConfig = { rowCount: 15, pageNumber: 1};

    useEffect(() => {
        let lastPage = false;
        if (invoiceableEntities) {
            lastPage = invoiceableEntities.pageNumber * invoiceableEntities.pageSize < invoiceableEntities.totalRecords;
        }
        setIsOnLastPage(lastPage);
    }, [invoiceableEntities]);

    const getInvoiceableEntities = async (filter: string, nextPage: boolean) => {
        const result = await get(`/v1.0/invoicing${filter}`);
        if (response.ok) {
            if (nextPage === true) {
                let tempResult = _.cloneDeep(invoiceableEntities);
                tempResult.pageNumber += 1;
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setInvoiceableEntities(tempResult);
            } else {
                setInvoiceableEntities(result);
            }
        } else {
            console.log('bad request', response, filters);
        }
    };

    const rightPanel = (contractType: string) => {
        return (
            <>
                <span className="right-panel">
                    <span>Contract Type - {contractType}</span>
                    {/* <div>Status: Rough Draft</div> */}
                </span>
            </>
        );
    };

    const searchUpdate = useCallback(
        _.debounce((filter: string) => {
            getInvoiceableEntities(filter, false);
        }, 800),
        []
    );

    const updateFilter = (options: ODataOptions) => {
        let configOptions = ODataOptions.from(initialInvoicingConfig);
        configOptions.merge(options);

        const stringOptions = configOptions.toString();
        setFilters(stringOptions);
        searchUpdate(stringOptions);
        console.log('New Filter Options', stringOptions);
    };

    const invoiceList = () => {
        return invoiceableEntities?.items?.map((ie: InvoiceableEntity, index: number) => {
            return (
                <div key={index}>
                    <Card
                        badge={`${ie.agreementNumber || 'N/A'}`}
                        onClick={() => dispatch(push(`/invoicing/${ie.contractLookupId}/invoicing-detail`))}
                        newContext={true}
                        showMenu={true}
                        rightBadgePanel={rightPanel(ie.contractType)}
                        infoBar={`Owner Name - ${ie.ownerName || 'N/A'}`}
                    >
                        <div className="agreements-card">
                            <div className="mr-2">
                                <div className="agreements-card-row" style={{ display: 'flex', width: '100%' }}>
                                    <div style={{ width: '25%' }}>
                                        <span className="card-label">Project: </span>
                                        <span className="data">
                                            {ie.projectName || 'N/A'} - {ie.projectNumber}
                                        </span>
                                    </div>

                                    <div style={{ width: '25%' }}>
                                        <span className="card-label">Client: </span>
                                        <span className="data">
                                            {ie.clientName || 'N/A'} - {ie.clientNumber}
                                        </span>
                                    </div>

                                    <div style={{ width: '15%' }}>
                                        <span className="card-label">Pending Invoices: </span>
                                        {ie.pendingInvoices}
                                    </div>

                                    <div style={{ width: '15%' }}>
                                        <span className="card-label">Posted Invoices: </span>
                                        {ie.postedInvoices}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div style={{ width: '50%', marginLeft: '50%' }}>{footerContent(1)}</div> */}
                    </Card>
                    {/* <Card>
                        <div>{`Invoice number ${ie.contractLookupId}`}</div>
                    </Card> */}
                </div>
            );
        });
    };

    const incrementPage = () => {
        let newConfig = initialInvoicingConfig;
        newConfig.pageNumber = invoiceableEntities.pageNumber + 1;

        const options = ODataOptions.from(newConfig);

        getInvoiceableEntities(options.toString(), true);
    };

    return (
        <>
            <div>
                <div style={{ marginLeft: '1rem' }}>
                    <h3>Invoicing</h3>
                </div>
                <Filter
                    sortItems={[
                        { group: 1, text: 'Contract Type', icon: 'alpha-up', orderName: 'contractType', orderDirection: 'ascending' },
                        { group: 1, text: 'Project Name', icon: 'alpha-up', orderName: 'projectName', orderDirection: 'ascending' },
                        { group: 1, text: 'Project Number', icon: 'numeric-up', orderName: 'projectNumber', orderDirection: 'ascending' },
                        { group: 1, text: 'Owner Name', icon: 'alpha-up', orderName: 'ownerName', orderDirection: 'ascending' },
                        { group: 1, text: 'Contract Number', icon: 'numeric-up', orderName: 'agreementNumber', orderDirection: 'ascending' },
                        { group: 1, text: 'Client Name', icon: 'alpha-up', orderName: 'clientName', orderDirection: 'ascending' },
                        { group: 1, text: 'Client Number', icon: 'alpha-up', orderName: 'clientNumber', orderDirection: 'ascending' },
                    ]}
                    filterItems={[
                        { group: 1, text: 'Contract Type', orderName: 'contractType', orderDirection: 'descending' },
                        { group: 1, text: 'Project Name', orderName: 'projectName', orderDirection: 'descending' },
                        { group: 1, text: 'Project Number', orderName: 'projectNumber', orderDirection: 'descending' },
                        { group: 1, text: 'Owner Name', orderName: 'ownerName', orderDirection: 'descending' },
                        { group: 1, text: 'Contract Number', orderName: 'agreementNumber', orderDirection: 'descending' },
                        { group: 1, text: 'Client Name', orderName: 'clientName', orderDirection: 'descending' },
                        { group: 1, text: 'Client Number', orderName: 'clientNumber', orderDirection: 'descending' },
                    ]}
                    onFilterChanged={updateFilter}
                />
                <div style={{ overflow: 'auto', maxHeight: '65vh' }} id="what">
                    <CardContainer
                        showNextPagePanel={isOnLastPage}
                        nextPageAction={incrementPage}
                    >
                        {invoiceList()}
                    </CardContainer>
                </div>
            </div>
        </>
    );
};

export default InvoicingPage;



// WEBPACK FOOTER //
// ./src/components/invoicing/pages/InvoicingPage.tsx